// @flow

import React from 'react';
import red from '@mui/material/colors/red';
import { log } from '../../utils/jsUtils';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import { createClasses } from '../../utils/stylesUtils';
import styles from './Styles/RemoveTenantDialog.Style';
import { useI18n } from '../../contexts/I18nContext';
import type { Tenant } from '../../services/SPBackend';

type Props = {
  setOpen: Function,
  open: boolean,
  actionConfirm: Function,
  tenant: Tenant
}

const RemoveTenantDialog = (props: Props) => {
  const {
    setOpen,
    open,
    actionConfirm,
    tenant
  } = props;
  
  const theme = useTheme();
  const classes = createClasses(styles, theme);
  const i18n = useI18n();

  // log('[RemoveTenantDialog] open: ', open);
  return (
    <Box>
    {
      (tenant !== null && typeof tenant !== 'undefined')
      ? <Dialog
          aria-labelledby='form-add-property'
          onClose={() => setOpen(false)}
          open={open}
        >
          <DialogTitle id='form-dialog-title'>
          {'HEADS UP!'}
          </DialogTitle>
          <DialogContent sx={{ ...classes.grow, ...classes.flexContainer }}>
            <DialogContentText>
              {`You are about to remove this ${i18n.t('tenant')} and all related ${i18n.t('tasks')} from your account:`}<br />
              <b style={{color: red[600]}}>{`${tenant.FirstName} ${tenant.LastName}`}</b><br /><br />
              {'Are you sure?'}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button 
              color='primary'
              onClick={() => setOpen(false)}
              type='button'
            >
              {'Cancel'}
              </Button>
            <Button 
              color='primary'
              onClick={() => { 
                actionConfirm(); 
                setOpen(false); 
                }
              }
              variant='contained'
            >
              {'Remove'}
              </Button>
          </DialogActions>
        </Dialog>
      : null
    }
    </Box>
  );
};

export default RemoveTenantDialog;